var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.dialogVisible)?_c('div',{staticClass:"PopUpPromptBj"},[_c('div',{staticClass:"PopUpPromptBox"},[_c('img',{staticStyle:{"margin":"20px 0 30px 0"},attrs:{"src":require("@/assets/warn.png")}}),_c('div',{staticStyle:{"margin-bottom":"20px"}},[_vm._v(_vm._s(_vm.title))])])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }